var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-users","titulo":"EQUIPE DE APOIO","subTitulo":"SGF"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'Gerentes_Apoios' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }